// Globo closes a focused submenu on mousedown in Safari before its link receives a click.
// Keep focus on the disclosure for that mouse press so the link can navigate normally.
if (navigator.vendor === 'Apple Computer, Inc.') {
  document.addEventListener(
    'mousedown',
    (event) => {
      if (
        event.button !== 0 ||
        event.metaKey ||
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey ||
        !(event.target instanceof Element)
      ) {
        return;
      }

      const link = event.target.closest('.gm-menu:not(.gm-menu-mobile) a.gm-target[href]');
      const focused = document.activeElement;
      if (
        link &&
        focused instanceof Element &&
        focused.matches('.gm-menu:not(.gm-menu-mobile) a.gm-target[data-gm-disclosure]')
      ) {
        event.preventDefault();
      }
    },
    true
  );
}
